var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { notification, Spin } from 'antd';
import LoadingOverlay from 'react-loading-overlay-ts';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from '../components/Sidebar';
import { getQzTrayDeviceContext, showQzConnectionWarningOnce } from '../helper/functions';
// import TestPrinter from '../components/TestPrinter'
import Language from '../components/ChangeLanguage';
import UserPreference from '../components/UserPreference';
import ScalePreference from '../components/ScalePreference';
var SettingScreen = function () {
    var t = useTranslation().t;
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState({
        hostname: null,
        isChecked: false
    }), qzHostnameState = _b[0], setQzHostnameState = _b[1];
    var hostname = qzHostnameState.hostname, isQzHostnameChecked = qzHostnameState.isChecked;
    var history = useHistory();
    useEffect(function () {
        var isAuth = localStorage.getItem('loggedInHH');
        if (!isAuth) {
            history.push('/');
        }
    }, [history]);
    var resolveQzHostname = useCallback(function (showWarning) {
        if (showWarning === void 0) { showWarning = true; }
        return __awaiter(void 0, void 0, Promise, function () {
            var _a, connected, detectedHostname;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getQzTrayDeviceContext()];
                    case 1:
                        _a = _b.sent(), connected = _a.connected, detectedHostname = _a.hostname;
                        if (!connected || !detectedHostname) {
                            if (showWarning) {
                                showQzConnectionWarningOnce(notification, t, function () { return getQzTrayDeviceContext(); });
                            }
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, detectedHostname];
                }
            });
        });
    }, [t]);
    var refreshQzHostname = useCallback(function (showWarning) {
        if (showWarning === void 0) { showWarning = true; }
        return __awaiter(void 0, void 0, Promise, function () {
            var detectedHostname;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, resolveQzHostname(showWarning)];
                    case 1:
                        detectedHostname = _a.sent();
                        setQzHostnameState(function (prevState) { return (__assign(__assign({}, prevState), { hostname: detectedHostname })); });
                        return [2 /*return*/, detectedHostname];
                }
            });
        });
    }, [resolveQzHostname]);
    useEffect(function () {
        var isMounted = true;
        var initQzHostname = function () { return __awaiter(void 0, void 0, void 0, function () {
            var detectedHostname;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, resolveQzHostname()];
                    case 1:
                        detectedHostname = _a.sent();
                        if (isMounted) {
                            setQzHostnameState({
                                hostname: detectedHostname,
                                isChecked: true
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        initQzHostname();
        return function () {
            isMounted = false;
        };
    }, [resolveQzHostname]);
    return (_jsx(LoadingOverlay, __assign({ active: isLoading || !isQzHostnameChecked, spinner: _jsx(Spin, {}, void 0) }, { children: _jsx(Sidebar, __assign({ setIsLoading: setIsLoading }, { children: _jsxs("div", __assign({ className: 'md:flex justify-center mt-4 md:mt-16' }, { children: [_jsx(Language, { setIsLoading: setIsLoading }, void 0), isQzHostnameChecked && (_jsxs(_Fragment, { children: [_jsx(UserPreference, { setIsLoading: setIsLoading, hostname: hostname, refreshQzHostname: refreshQzHostname }, void 0), _jsx(ScalePreference, { setIsLoading: setIsLoading, hostname: hostname, refreshQzHostname: refreshQzHostname }, void 0)] }, void 0))] }), void 0) }), void 0) }), void 0));
};
export default SettingScreen;
